// const topSplideSlider_main = '#top-splide-slider';
// const topSplideSlider_options = {
//   mediaQuery: 'max',
//   type   : 'loop',
//   autoplay: false,
//   perPage: 2,
//   rewind: true,
//   focus  : 'center',
//   pagination: false,
//   arrows: true,
//   updateOnMove: true,
//   isNavigation: true,
//   fixedWidth: '768px',
//   breakpoints: {
//     768: {
//       destroy: true,
//     }
//   },
// }
// if (document.querySelectorAll(topSplideSlider_main).length > 0) {
//   const topSplideSlider = new Splide(topSplideSlider_main, topSplideSlider_options);
//   topSplideSlider.mount();
// }

// const topSplideSliderSP_main = '#top-splide-slider_sp';
// const topSplideSliderSP_options = {
//   mediaQuery: 'min',
//   type   : 'loop',
//   autoplay: false,
//   perPage: 1,
//   rewind: true,
//   focus  : 'center',
//   pagination: true,
//   arrows: true,
//   updateOnMove: true,
//   isNavigation: true,
//   breakpoints: {
//     769: {
//       destroy: true,
//     }
//   },
// }
// if (document.querySelectorAll(topSplideSliderSP_main).length > 0) {
//   const topSplideSliderSP = new Splide(topSplideSliderSP_main, topSplideSliderSP_options);
//   topSplideSliderSP.mount();
// }

document.addEventListener('DOMContentLoaded', function() {
  const topSplideSlider_main = '#top-splide-slider';
  const topSplideSliderSP_main = '#top-splide-slider_sp';

  // スライダーのオプション設定
  const topSplideSlider_options = {
    mediaQuery: 'max',
    type   : 'loop',
    autoplay: true,
    perPage: 2,
    rewind: true,
    focus  : 'center',
    pagination: false,
    arrows: true,
    updateOnMove: true,
    isNavigation: true,
    fixedWidth: '768px',
    breakpoints: {
      768: {
        destroy: true,
      }
    }
  };

  const topSplideSliderSP_options = {
    mediaQuery: 'min',
    type   : 'loop',
    autoplay: true,
    perPage: 1,
    rewind: true,
    focus  : 'center',
    pagination: true,
    arrows: true,
    updateOnMove: true,
    isNavigation: true,
    breakpoints: {
      769: {
        destroy: true,
      }
    }
  };

  // IntersectionObserverを使って遅延読み込み
  const observerOptions = {
    root: null, // ビューポートを基準にする
    threshold: 0.1, // 10%表示されたら発火
  };

  const initSplideSlider = (element, options) => {
    if (document.querySelectorAll(element).length > 0) {
      const splideSlider = new Splide(element, options);
      splideSlider.mount();
    }
  };

  // スライダーの要素と設定を配列でまとめる
  const sliders = [
    { selector: topSplideSlider_main, options: topSplideSlider_options },
    { selector: topSplideSliderSP_main, options: topSplideSliderSP_options }
  ];

  // 各スライダーに対してObserverを適用
  sliders.forEach(slider => {
    const targetElement = document.querySelector(slider.selector);
    if (targetElement) {
      const observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Splide.js スライダーを初期化
            initSplideSlider(slider.selector, slider.options);
            observer.disconnect(); // 初期化後はObserverを解除
          }
        });
      }, observerOptions);

      observer.observe(targetElement); // Observerを適用
    }
  });
});


const shopDetailSplideSlider_main = '#shop-detail-slider';
const shopDetailSplideSlider_options = {
  mediaQuery: 'min',
  type   : 'loop',
  autoplay: false,
  perPage: 1,
  rewind: true,
  focus  : 'center',
  pagination: true,
  arrows: false,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    640: {
      // destroy: true,
      perPage: 3,
      gap: "10px",
    }
  },
}
if (document.querySelectorAll(shopDetailSplideSlider_main).length > 0) {
  const shopDetailSplideSlider = new Splide(shopDetailSplideSlider_main, shopDetailSplideSlider_options);
  shopDetailSplideSlider.mount();
}